import React, { FC } from 'react';
import { components } from './data';

export const SKPublicRecentSwaps: FC = () => {
  return (
    <>
      {components.map(({ name }, index) => {
        const C = name;
        return <C key={`component-${index}`} />;
      })}
    </>
  );
};
